import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

import ChatterMessage from 'js/chatter/chatElements/ChatterMessage';

import Modal from 'components/Modal';

class ClosedChatHistory extends React.Component {
  render() {
    const {
      intl: { messages },
      show,
      close,
      chatDetails,
    } = this.props;

    const {
      data: { customer_chat: customerChat, messages: chatMessages },
    } = chatDetails;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>Chat history</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="chat-view">
            {chatMessages &&
              chatMessages.map(message => {
                return (
                  <ChatterMessage
                    key={messages.id}
                    message={message}
                    fromMe={customerChat.creator === message.creator}
                  />
                );
              })}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ClosedChatHistory)));
